// extracted by mini-css-extract-plugin
export default {"sortable":"SortableHeader_sortable__lY7lU","whiteRightBorder":"SortableHeader_whiteRightBorder__cBp-n"};